import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PreProjectsTotalAddFileComponent } from '../preprojects-totals-add-file/preprojects-totals-add-file.component';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';
import { ProjectModel } from 'src/app/models/project.model';

@Component({
  selector: 'app-preprojects-totals-add',
  templateUrl: './preprojects-totals-add.component.html',
  styleUrls: ['./preprojects-totals-add.component.scss']
})
export class ProjectsTotalsAddComponent implements OnInit {
  project: ProjectModel = new ProjectModel();
  id_camp : number = 0;
  isLoading = true;
  totalFiles: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectsTotalsAddComponent>,
  ) {
    this.id_camp = this.data.id_camp;
    this.loadData();
   }

  ngOnInit(): void {
  }

  loadData(){
    this.projectService.getPreprojectTotals(this.id_camp ).subscribe(
      (result:any) => {
        this.isLoading = false;
       this.totalFiles = result.data.totals;
      },
      (err:any) => {
        this.isLoading = false;
        if(err.error.message != "No valid art files were found in the request")
        {
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
        }
      }
    );
  }

  openDialogUploadFile() {
    this.matDialog.open(PreProjectsTotalAddFileComponent, {
      panelClass: ['dialogs-main'],
      data: {
        id_camp: this.id_camp 
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.loadData();
        }
      }
    );
  }

}
